import { AlertCircle, Info } from "lucide-react";
import { useToast } from "@/hooks/use-toast";
import { Toast, ToastClose, ToastDescription, ToastProvider, ToastTitle, ToastViewport } from "@/components/ui/toast";

// #77: Toasts had color-only signal (red=error, default=info). Now
// every variant carries an icon + an sr-only role-prefix so screen
// readers + color-blind users can tell errors from info at a glance.

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, variant, ...props }) {
        const isError = variant === 'destructive';
        const Icon = isError ? AlertCircle : Info;
        const srPrefix = isError ? 'Error:' : 'Info:';
        return (
          <Toast key={id} variant={variant} {...props}>
            <div className="flex items-start gap-3">
              <Icon className="w-4 h-4 mt-0.5 flex-shrink-0" aria-hidden="true" />
              <div className="grid gap-1">
                {title && (
                  <ToastTitle>
                    <span className="sr-only">{srPrefix} </span>
                    {title}
                  </ToastTitle>
                )}
                {description && <ToastDescription>{description}</ToastDescription>}
              </div>
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
